import {
  Box,
  FormHelperText,
  Typography
} from '@mui/material';

interface NoQuestionnaireProps {
  headingColor?: string
}

const NoQuestionnaire: React.FC<NoQuestionnaireProps> = ({ headingColor = 'rgb(213, 213, 213)' }) => (
  <Box padding="0.9rem" width={'100%'} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <FormHelperText sx={{ fontSize: '1rem', mb: '0.4rem', color: headingColor }}>
      No Questionnaire
    </FormHelperText>
    <Typography color="GrayText" textAlign={'center'}>
      {"KYC questionnaires are unavailable"}<br />{"at this moment"}
    </Typography>
  </Box>
);

export default NoQuestionnaire;
